module.exports = __webpack_public_path__ + "assets/img/aiwriter-func1.c6fdbb60.png";